import { ReactNode } from 'react';
import { ArrowUpward, ArrowDownward } from '@mui/icons-material';
import styles from './ComparisonChartCard.module.css';
import { ActionButton, PlantIcon } from '@practium/ui';

export interface ComparisonChartCardProps {
	title: string;
	buttonText: string;
	onButtonClick: () => void;
	valueLabel?: string;
	mainValue?: string;
	trendValue?: string;
	trendLabel?: string;
	trendDirection?: 'up' | 'down';
	footerText?: string;
	children: ReactNode;
	legend?: ReactNode;
	isEmpty?: boolean;
	emptyMessage?: string;
	isLoading?: boolean;
	skeleton?: ReactNode;
}

export const ComparisonChartCard = ({
	title,
	buttonText,
	onButtonClick,
	valueLabel,
	mainValue,
	trendValue,
	trendLabel,
	trendDirection,
	footerText,
	children,
	legend,
	isEmpty,
	emptyMessage = 'Nenhum dado disponível',
	isLoading,
	skeleton,
}: ComparisonChartCardProps) => {
	const trendColorClass = trendDirection === 'up' ? styles.trendUp : styles.trendDown;
	const hasInfo = Boolean(mainValue || footerText || (trendValue && trendLabel && trendDirection));

	return (
		<div className={styles.card}>
			<div className={styles.header}>
				<span className={styles.title}>{title}</span>
				<div className={styles.buttonWrapper}>
					<ActionButton text={buttonText} onClick={onButtonClick} />
				</div>
			</div>

			{isLoading ? (
				<div className={styles.skeleton}>{skeleton}</div>
			) : (
				<>
					{!isEmpty && hasInfo && (
						<div className={styles.info}>
							<div className={styles.valueGroup}>
								{valueLabel && <span className={styles.valueLabel}>{valueLabel}</span>}
								{mainValue && <span className={styles.mainValue}>{mainValue}</span>}
								{trendValue && trendLabel && trendDirection && (
									<div className={styles.trend}>
										{trendDirection === 'up' ? (
											<ArrowUpward className={`${styles.trendIcon} ${trendColorClass}`} />
										) : (
											<ArrowDownward className={`${styles.trendIcon} ${trendColorClass}`} />
										)}
										<span className={`${styles.trendValue} ${trendColorClass}`}>{trendValue}</span>
										<span className={styles.trendLabel}>{trendLabel}</span>
									</div>
								)}
							</div>
							{footerText && <span className={styles.footerText}>{footerText}</span>}
						</div>
					)}

					<div className={styles.chartContent}>
						{isEmpty ? (
							<div className={styles.emptyState}>
								<PlantIcon className={styles.emptyIcon} />
								<span className={styles.emptyMessage}>{emptyMessage}</span>
							</div>
						) : (
							children
						)}
					</div>

					{!isEmpty && legend && <div className={styles.legend}>{legend}</div>}
				</>
			)}
		</div>
	);
};
